import { getToken } from '../selectors/tokenSelector';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { call, put } from 'redux-saga/effects';
import env from 'config/env';
import * as types from 'constants/actionTypes';

const reportsUtil = {
    get: function* (url, name) {
        let token = getToken();
        yield put({ type: types.SHOW_DOWNLOADING });

        const headers = {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            timezone_offset: new Date(Date.now()).getTimezoneOffset(),
        };

        try {
            const res = yield call(axios.get, `${env.reportsAPIUrl()}${url}`, { responseType: "arraybuffer", headers });
            if (res.headers["content-type"] == "application/zip"){
                yield call(fileDownload, res.data, `${name}.zip`);
            } else if (res.headers["content-type"] == "application/x-tar"){
                yield call(fileDownload, res.data,`${name}.tar`);
            } else {
                yield call(fileDownload, res.data, `${name}.csv`);
            }
            
            yield put({ type: types.HIDE_LOADING });
        } catch (error) {
            console.log(error);
            alert("Failed download file")
            yield put({ type: types.HIDE_LOADING });
        }
    },
    getWithStatus: function* (url, name) {
        let token = getToken();
        yield put({ type: types.SHOW_DOWNLOADING });

        const headers = {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            timezone_offset: new Date(Date.now()).getTimezoneOffset(),
        };

        try {
            const res = yield call(axios.get, `${env.reportsAPIUrl()}${url}`, { headers });
            if (res.status == 200) {
                yield call(fileDownload, res.data, `${name}.csv`);
                yield put({ type: types.HIDE_LOADING });
                yield put({ type: types.REPORT_LOADING_COMPLETE });
                yield put({
                    type: 'LOADING',
                    val: -1
                });
            }
        } catch (error) {
            if (error.response.status == 425) {
                console.log("downloading...")
            }
            else if (error.response.status != 425) {
                console.log(error);
                alert("Failed download file")
                yield put({ type: types.HIDE_LOADING });
                yield put({ type: types.REPORT_LOADING_COMPLETE });
            }
        }
    }
};

export default reportsUtil;
